import React from "react";

const DeveloperOptions = (props) => {
    const trackingList = [
        { name: "audio", label: "Noise" },
        { name: "numHumans", label: "No/Multiple Faces" },
        { name: "tabSwitch", label: "Tab Switch" },
        { name: "detectMultipleScreens", label: "External Monitors" },
        { name: "photosAtRandom", label: "Random Photos" },
        { name: "forceFullScreen", label: "Enforce Full Screen" },
    ];

    return (
        <>
            <div className="sticky top-2 z-50 developer-option bg-gray-100 rounded-xl m-5 px-5 py-3 mb-0 shadow-md">
                <h3 className="text-gray-800 font-bold mb-3">What to track</h3>
                <div className="grid grid-cols-4 gap-y-3 mb-3">
                    <div className="col-span-3 grid grid-cols-3 gap-y-3">
                        {trackingList.map((track) => (
                            <Checkbox
                                key={track.name}
                                name={track.name}
                                checked={props.currSetting[track.name]}
                                onChange={props.handleInputChange}
                                label={track.label}
                            />
                        ))}
                    </div>
                    <div className="col-span-1 flex items-center">
                        <div className="text-sm text-gray-600">
                            <p className="mb-1">Even more proctoring features:</p>
                            <ul className="list-disc list-inside xl:grid xl:grid-cols-2 xl:gap-x-4">
                                <li><a href="/developers/docs/configure/default-options#tracking-options" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Session Recording</a></li>
                                <li><a href="/developers/docs/configure/auxiliary-device" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Auxiliary Device</a></li>
                                <li><a href="/developers/docs/configure/id-card-verification" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">ID Card Verification</a></li>
                                <li><a href="/developers/docs/configure/impersonation-detection" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Impersonation Detection</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const Checkbox = ({ name, checked, onChange, label }) => {
    return (
        <div className="flex col-span-1 items-center">
            <label htmlFor={name} className="relative inline-block w-11 h-6 mr-2">
                <input
                    type="checkbox"
                    name={name}
                    id={name}
                    className="opacity-0 w-0 h-0 disable-while-proctoring"
                    onChange={onChange}
                    checked={checked}
                />
                <span
                    className={`absolute cursor-pointer top-0 left-0 right-0 bottom-0 rounded-full transition duration-400 ${
                        checked ? "bg-emerald-500" : "bg-gray-200"
                    }`}
                >
                    <span
                        className={`absolute left-0.5 top-0.5 bg-white w-5 h-5 rounded-full shadow-md transition duration-400 transform ${
                            checked ? "translate-x-5" : ""
                        }`}
                    ></span>
                </span>
            </label>
            <span className={`text-sm ${checked ? "text-gray-900" : "text-gray-500"}`}>{label}</span>
        </div>
    );
};

export default DeveloperOptions;
